import About from "../components/About";
import Header from "../components/Header";
import Footer from "../components/Footer";
const AboutPage = () => {
  return (
    <div className="about-page">
      <Header />
      <About />
      <Footer />
    </div>
  );
};

export default AboutPage;
